import { BASE_URL } from "@/constants/constants";
import { useEffect } from "react";
import {
  Outlet,
  useNavigationType,
  useLocation,
  useNavigate,
} from "react-router-dom";

const MainLayout = () => {
  const location = useLocation();
  const navigationType = useNavigationType();
  const navigate = useNavigate();

  useEffect(() => {
    if (navigationType !== "PUSH" && navigationType !== "POP") {
      if (location.pathname.includes(`${BASE_URL}/capture`)) {
        navigate(`${BASE_URL}/capture`);
      } else {
        navigate(`${BASE_URL}`);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (navigationType === "POP") {
      navigate(`${BASE_URL}`);
    }
  }, [navigationType, location.pathname, navigate]);

  return (
    <div
      data-testid={"main-layout"}
      id={"main-layout"}
      className="h-fulldpx overflow-y-auto"
    >
      <Outlet />
    </div>
  );
};

export default MainLayout;
